import { getPatient } from '../../../../../graphql/queries';
import { GetPatientQuery } from '@/API';
import { useEffect, useState } from 'react';
import awsconfig from '@/amplifyconfiguration.json';
import { fetchAuthSession } from 'aws-amplify/auth';
import { Amplify } from 'aws-amplify';
import { executeQuery } from '@/client/graphql';

Amplify.configure(awsconfig);

export const useGetPatient = () => {
  const [patient, setPatient] = useState<GetPatientQuery | undefined>();
  const [loading, setLoading] = useState<boolean>(true);

  const loadPatientData = async () => {
    try {
      const session = await fetchAuthSession();
      const res = await executeQuery<GetPatientQuery>(getPatient, { id: session.userSub as string }, 'userPool');
      setPatient(res ?? undefined);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPatientData();
  }, []);

  return {
    patient,
    loading
  };
};
